import React from "react"
import PropTypes from "prop-types"
import cn from "classnames"

import styles from "./appbar-tail.module.css"

export const AppbarTail = ({ children, bezel = true, ...props }) => {
  // filtering out style and className
  /* eslint-disable-next-line react/prop-types */
  const { style, className, ...rest } = props

  return (
    <div
      {...rest}
      className={cn(styles.AppbarTail, { [styles.bezelless]: !bezel })}
    >
      {children}
    </div>
  )
}

AppbarTail.displayName = "AppbarTail"

AppbarTail.propTypes = {
  /**
   * Container for the AppbarTail content.
   */
  children: PropTypes.node.isRequired,
  /**
   * Adds padding.
   */
  bezel: PropTypes.bool,
}

AppbarTail.defaultProps = {
  bezel: true,
}
